// // import { Facebook, Instagram, Twitter } from 'lucide-react';

// // export default function Footer() {
// //   return (
// //     <footer className="bg-secondary-dark text-white py-8">
// //       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
// //         <div className="grid md:grid-cols-3 gap-8">
// //           {/* Company Info */}
// //           <div>
// //             <h3 className="text-3xl font-heading font-bold text-accent-base mb-4">Capital Offset</h3>
// //             <p className="text-gray-300 mb-4">
// //               We provide high-quality printing services in Ahmedabad, specializing in brochure, book, box, and more. With years of expertise, we deliver professional solutions for businesses across various industries.
// //             </p>
// //             <p className="text-gray-300">
// //               <strong>Contact Us:</strong><br />
// //               1234 Printing Lane, Ahmedabad, Gujarat, India <br />
// //               Phone: +91 123 456 7890<br />
// //               Email: <a href="mailto:info@satyamscan.com" className="text-accent-light hover:text-white">info@satyamscan.com</a>
// //             </p>
// //           </div>

// //           {/* Quick Links */}
// //           <div>
// //             <h3 className="text-2xl font-bold text-accent-base mb-4">Quick Links</h3>
// //             <ul className="space-y-2 text-gray-300">
// //               <li>
// //                 <a href="/" className="hover:text-accent-light transition-colors duration-300">Home</a>
// //               </li>
// //               <li>
// //                 <a href="/about" className="hover:text-accent-light transition-colors duration-300">About Us</a>
// //               </li>
// //               <li>
// //                 <a href="/services" className="hover:text-accent-light transition-colors duration-300">Services</a>
// //               </li>
// //               <li>
// //                 <a href="/portfolio" className="hover:text-accent-light transition-colors duration-300">Portfolio</a>
// //               </li>
// //               <li>
// //                 <a href="/contact" className="hover:text-accent-light transition-colors duration-300">Contact</a>
// //               </li>
// //             </ul>
// //           </div>

// //           {/* Social Media Links */}
// //           <div>
// //             <h3 className="text-2xl font-bold text-accent-base mb-4">Follow Us</h3>
// //             <div className="flex space-x-6">
// //               <a href="https://www.facebook.com/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Facebook className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //               <a href="https://www.instagram.com/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Instagram className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //               <a href="https://www.twitter.com/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Twitter className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //               <a href="https://www.linkedin.com/company/satyamscan" target="_blank" rel="noopener noreferrer">
// //                 <Twitter className="w-6 h-6 text-gray-300 hover:text-accent-light transition-colors duration-300" />
// //               </a>
// //             </div>
// //           </div>
// //         </div>

// //         <div className="border-t border-gray-700 mt-8 pt-6">
// //           <div className="flex justify-between items-center">
// //             <p className="text-gray-300 text-sm">&copy; 2025 Capital Offset. All rights reserved.</p>
// //             <div className="text-sm text-gray-300">
// //               <a href="/privacy-policy" className="hover:text-accent-light transition-colors duration-300 mr-4">Privacy Policy</a>
// //               <a href="/terms-of-service" className="hover:text-accent-light transition-colors duration-300">Terms of Service</a>
// //             </div>
// //           </div>
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // }

// import { Facebook, Instagram, Twitter } from 'lucide-react';
// import { Link } from 'react-router-dom';

// export default function Footer() {
//   return (
//     <footer className="bg-primary-dark text-white py-10">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         {/* Logo Section */}
//         <div className="flex items-center justify-center md:justify-start mb-8">
//           <Link href="/">
//             <a>
//               <img src="/logo.png" alt="Satyamscan" className="w-32" />
//             </a>
//           </Link>
//         </div>

//         {/* Footer Grid */}
//         <div className="grid md:grid-cols-3 gap-12">
//           {/* Company Info */}
//           <div>
//             <h3 className="text-2xl font-semibold text-accent-base mb-4">About Satyamscan</h3>
//             <p className="text-gray-300 mb-4">
//               We provide premium quality printing services in Ahmedabad, specializing in a wide range of products such as brochures, books, and packaging. Our goal is to deliver exceptional results to our clients with precision and professionalism.
//             </p>
//             <p className="text-gray-300">
//               <strong>Contact Us:</strong><br />
//               1234 Printing Lane, Ahmedabad, Gujarat, India <br />
//               Phone: <a href="tel:+911234567890" className="text-accent-light hover:text-white">+91 123 456 7890</a><br />
//               Email: <a href="mailto:info@satyamscan.com" className="text-accent-light hover:text-white">info@satyamscan.com</a>
//             </p>
//           </div>

//           {/* Quick Links */}
//           <div>
//             <h3 className="text-2xl font-semibold text-accent-base mb-4">Quick Links</h3>
//             <ul className="space-y-3 text-gray-300">
//               <li>
//                 <Link href="/">
//                   <a className="hover:text-accent-light transition-colors duration-300">Home</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/about">
//                   <a className="hover:text-accent-light transition-colors duration-300">About Us</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/services">
//                   <a className="hover:text-accent-light transition-colors duration-300">Services</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/portfolio">
//                   <a className="hover:text-accent-light transition-colors duration-300">Portfolio</a>
//                 </Link>
//               </li>
//               <li>
//                 <Link href="/contact">
//                   <a className="hover:text-accent-light transition-colors duration-300">Contact</a>
//                 </Link>
//               </li>
//             </ul>
//           </div>

//           {/* Social Media Links */}
//           <div>
//             <h3 className="text-2xl font-semibold text-accent-base mb-4">Follow Us</h3>
//             <div className="flex space-x-6">
//               <a href="https://www.facebook.com/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
//                 <Facebook className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//               <a href="https://www.instagram.com/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
//                 <Instagram className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//               <a href="https://www.twitter.com/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
//                 <Twitter className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//               <a href="https://www.linkedin.com/company/satyamscan" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
//                 <Twitter className="w-7 h-7 text-gray-300 hover:text-accent-light transition-colors duration-300" />
//               </a>
//             </div>
//           </div>
//         </div>

//         {/* Legal Links */}
//         <div className="border-t border-gray-700 mt-12 pt-8">
//           <div className="flex justify-between items-center">
//             <p className="text-gray-300 text-sm">
//               &copy; 2025 Satyamscan. All rights reserved.
//             </p>
//             <div className="text-sm text-gray-300 space-x-4">
//               <Link href="/privacy-policy">
//                 <a className="hover:text-accent-light transition-colors duration-300">Privacy Policy</a>
//               </Link>
//               <Link href="/terms-of-service">
//                 <a className="hover:text-accent-light transition-colors duration-300">Terms of Service</a>
//               </Link>
//             </div>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

import React from 'react';
import { Mail, Phone, MapPin, Facebook, Twitter, Code } from 'lucide-react';
import { Link } from 'react-router-dom'; // For routing links
import logo from '../assets/Untitled design (3).svg'
import { FiFacebook, FiGithub, FiInstagram, FiLinkedin, FiMail, FiMapPin, FiPhone, FiTwitter } from 'react-icons/fi';
const Footer = () => {
  return (
    <footer className="bg-galaxyBlack text-white border-t border-electricindigo-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid md:grid-cols-4 gap-8 ">
            <div>
              <h3 className="text-cyan-400 text-2xl font-semibold ">CapitalPlus <div className="text-white text-2xl font-semibold mb-4">Software</div>
              </h3>
            
              <p className="text-electricindigo-300 text-sm">
              Lighting the path to efficient DevOps solutions, we accelerate innovation through seamless automation. 
              </p>
            </div>
            <div className='text-center'>
              <h4 className="text-electricindigo-200 font-medium mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li> <Link to="/about" className="text-electricindigo-300 hover:text-cyan-300 text-sm">About</Link></li>
                <li> <Link to="/services" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Services</Link></li>
                <li> <Link to="/devops-automation" className="text-electricindigo-300 hover:text-cyan-300 text-sm">DevOps Automation</Link></li>
                <li> <Link to="/cloud-migration" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Cloud Migration</Link></li>
                <li> <Link to="/compliance-security" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Compliance & Security</Link></li>

              </ul>
            </div>
            <div className='text-center'>
              <h4 className="text-electricindigo-200 font-medium mb-4">Platforms</h4>
              <ul className="space-y-2">
                <li> <Link to="/platforms" className="text-electricindigo-300 hover:text-cyan-300 text-sm">AWS</Link></li>
                <li> <Link to="/platforms" className="text-electricindigo-300 hover:text-cyan-300 text-sm">GCP</Link></li>
                <li> <Link to="/platforms" className="text-electricindigo-300 hover:text-cyan-300 text-sm">Azure</Link></li>
              </ul>
            </div>
            <div className='text-center'>
              <h4 className="text-electricindigo-200 font-medium mb-4">Contact</h4>
              <ul className="space-y-2 text-sm text-electricindigo-300">
                <li className="flex items-center gap-2">
                  <FiMapPin className="w-4 h-4 text-cyan-400" />
                  6th Floor, Haveli Arcade, 603 - 604, Sector 11, Gandhinagar, Gujarat 382011
                </li>
                <li className="flex items-center gap-2">
                  <FiMail className="w-4 h-4 text-cyan-400" />
                  hello@capitalplussoftware.com
                </li>
                <li className="flex items-center gap-2">
                  <FiPhone className="w-4 h-4 text-cyan-400" />
                  6354616326
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-electricindigo-800/50 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <div className="text-electricindigo-400 text-sm mb-4 md:mb-0">
              © 2025 Capital Plus Software
            </div>
            <div className="flex space-x-6">
              <a href="https://www.instagram.com/capitalplussoft" className="text-electricindigo-300 hover:text-cyan-300">
                <FiInstagram className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/capital-plus-software/about/?viewAsMember=true" className="text-electricindigo-300 hover:text-cyan-300">
                <FiLinkedin className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/capitalplussoft" className="text-electricindigo-300 hover:text-cyan-300">
                <FiFacebook className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>
      </footer>
  );
};

export default Footer;
